import { computed, ComputedRef } from 'vue'

// Config
import { BookingStatus } from '@/config'

// Types
import type { BookingSummary } from '@/services/BookingService.interface' // Adjust to correct path

/**
 * A composable function that returns computed properties related to booking status.
 *
 * @param booking - The booking object to analyze.
 */
export const useBookingStatus = (
  booking: BookingSummary | null
): {
  isReservationStatus: ComputedRef<boolean>
  isQuoteOrCartInProgress: ComputedRef<boolean>
  isPastStatus: ComputedRef<boolean>
} => {
  const isReservationStatus: ComputedRef<boolean> = computed(() => {
    return booking?.status === BookingStatus.Reservation
  })

  const isQuoteOrCartInProgress: ComputedRef<boolean> = computed(() => {
    return (
      booking?.status === BookingStatus.Quote ||
      booking?.status === BookingStatus.CartInProgress
    )
  })

  const isPastStatus: ComputedRef<boolean> = computed(() => {
    return (
      booking?.status === BookingStatus.Billed ||
      booking?.status === BookingStatus.CancelledAfterBilling
    )
  })

  return {
    isReservationStatus,
    isQuoteOrCartInProgress,
    isPastStatus,
  }
}
